import { useState, useEffect, useCallback } from 'react'

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return isOnline
}

export function useOfflineSync() {
  const isOnline = useOnlineStatus()

  const queueSync = useCallback(
    (url: string, method: string, body: string, headers?: Record<string, string>) => {
      if (navigator.serviceWorker?.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'QUEUE_SYNC',
          payload: {
            url,
            method,
            headers: { 'Content-Type': 'application/json', ...headers },
            body,
          },
        })

        // Request background sync when online
        navigator.serviceWorker.ready.then((reg) => {
          if ('sync' in reg) {
            ;(reg as any).sync.register('agrobio-sync')
          }
        })
      }
    },
    []
  )

  return { isOnline, queueSync }
}
